import PropTypes from "prop-types";
import { useField } from "formik";

import InputFieldComponent from "common/components/form-fields/input/input.component";

function InputField({
  variant,
  label,
  margin,
  fullWidth,
  required,
  className,
  multiline,
  rows,
  placeholder,
  type,
  inputPropsOptions,
  disabled,
  ...props
}) {
  const [field, meta] = useField(props);

  const { name, onBlur, onChange, value } = field;
  const { touched, error } = meta;

  return (
    <InputFieldComponent
      name={name}
      touched={touched}
      error={error}
      inputPropsOptions={{ autoComplete: "off", ...inputPropsOptions }}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      variant={variant}
      label={label}
      margin={margin}
      fullWidth={fullWidth}
      required={required}
      className={className}
      multiline={multiline}
      rows={rows}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
  );
}

InputField.propTypes = {
  variant: PropTypes.oneOf(["standard", "outlined", "filled"]).isRequired,
  label: PropTypes.string.isRequired,
  margin: PropTypes.oneOf(["none", "dense", "normal"]).isRequired,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["text", "number"]),
  inputPropsOptions: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool,
};

InputField.defaultProps = {
  fullWidth: false,
  required: false,
  className: "",
  multiline: false,
  rows: "",
  placeholder: "",
  type: "text",
  inputPropsOptions: {},
  disabled: false,
};

export default InputField;
